import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", {
  role: "button",
  class: "fl mt5 mr20 mr4",
  style: {}
}, "複製", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_5 = ["src"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", {
  role: "button",
  class: "fl mt5 mr20 mr4",
  style: {}
}, "編集", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_8 = ["src"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", {
  role: "button",
  class: "fl mt5 mr20 alertRed",
  style: {}
}, "終了", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_11 = ["src"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", {
  role: "button",
  class: "fl mt5 mr20",
  style: {}
}, "履歴を確認", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_14 = ["src"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", {
  role: "button",
  class: "fl mt5 mr20",
  style: {}
}, "権限を共有", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_17 = ["src"]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", {
  role: "button",
  class: "fl mt5 mr20 alertRed",
  style: {}
}, "削除", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_20 = ["src"]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("p", {
  role: "button",
  class: "fl mt5 mr4",
  style: {}
}, "未確定の調整", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_23 = ["src"]
const _hoisted_24 = /*#__PURE__*/_createElementVNode("p", {
  role: "button",
  class: "fl mt5 mr4 fs12",
  style: {"width":"100px"}
}, "フォームに事前入力したURLを生成", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("p", {
  role: "button",
  class: "fr mt5 mr4",
  style: {}
}, "一斉キャンセル", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_28 = [
  _hoisted_26,
  _hoisted_27
]
const _hoisted_29 = /*#__PURE__*/_createElementVNode("p", {
  role: "button",
  class: "fr mt5 mr4",
  style: {}
}, "キャンセル・再調整", -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_31 = [
  _hoisted_29,
  _hoisted_30
]
const _hoisted_32 = /*#__PURE__*/_createElementVNode("p", {
  role: "button",
  class: "fr mt5 mr4",
  style: {}
}, "アクティブに戻す", -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_34 = [
  _hoisted_32,
  _hoisted_33
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")!

  return (_openBlock(), _createBlock(_component_Dropdown, {
    ref: "dropdown",
    id: "roomEditMenu",
    style: {"min-width":"100px"}
  }, {
    dropdown: _withCtx(() => [
      (_ctx.room.is_owner_group && _ctx.room.status != -10 && ['parent_room', 'public_room'].includes(_ctx.room.room_type))
        ? (_openBlock(), _createElementBlock("li", {
            key: 0,
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.copyPage && _ctx.copyPage(...args))),
            class: "fs12 pointer fw600 pad5",
            style: {"line-height":"40px","width":"160px"}
          }, [
            _createElementVNode("img", {
              src: _ctx.$getAssetImageUrl(`/assets/icons/copy_icon.png`),
              width: "17",
              height: "17",
              class: "ml14 fl mt4 mr20",
              style: {}
            }, null, 8, _hoisted_2),
            _hoisted_3,
            _hoisted_4
          ]))
        : _createCommentVNode("", true),
      (_ctx.showEditColumn)
        ? (_openBlock(), _createElementBlock("li", {
            key: 1,
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.editPage && _ctx.editPage(...args))),
            class: "fs12 pointer fw600 pad5",
            style: {"line-height":"40px","width":"160px"}
          }, [
            _createElementVNode("img", {
              src: _ctx.$getAssetImageUrl(`/assets/icons/editPen.png`),
              width: "17",
              height: "17",
              class: "ml15 fl mt4 mr20",
              style: {}
            }, null, 8, _hoisted_5),
            _hoisted_6,
            _hoisted_7
          ]))
        : _createCommentVNode("", true),
      (_ctx.room.is_owner_group && [101, 111, 112, 121, 199].includes(_ctx.room.status) && _ctx.canDelete)
        ? (_openBlock(), _createElementBlock("li", {
            key: 2,
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.showCloseRoomModal && _ctx.showCloseRoomModal(...args))),
            class: "fs12 pointer fw600 pad5",
            style: {"line-height":"40px","width":"160px"}
          }, [
            _createElementVNode("img", {
              src: _ctx.$getAssetImageUrl(`/assets/icons/status_ng.png`),
              width: "17",
              height: "17",
              class: "ml17 fl mt6 mr20",
              style: {}
            }, null, 8, _hoisted_8),
            _hoisted_9,
            _hoisted_10
          ]))
        : _createCommentVNode("", true),
      (_ctx.room.is_owner_group && _ctx.room.room_type == `parent_room`)
        ? (_openBlock(), _createElementBlock("li", {
            key: 3,
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.goSummary(_ctx.room))),
            class: "fs12 pointer fw600 pad5",
            style: {"line-height":"40px","width":"160px"}
          }, [
            _createElementVNode("img", {
              src: _ctx.$getAssetImageUrl(`/assets/icons/form_icon.png`),
              width: "17",
              height: "17",
              class: "ml17 fl mt6 mr20",
              style: {}
            }, null, 8, _hoisted_11),
            _hoisted_12,
            _hoisted_13
          ]))
        : _createCommentVNode("", true),
      (_ctx.room.is_owner && _ctx.room.room_type == `public_room`)
        ? (_openBlock(), _createElementBlock("li", {
            key: 4,
            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.showShareAuthModal && _ctx.showShareAuthModal(...args))),
            class: "fs12 pointer fw600 pad5",
            style: {"line-height":"40px","width":"160px"}
          }, [
            _createElementVNode("img", {
              src: _ctx.$getAssetImageUrl(`/assets/icons/waaq_members.png`),
              width: "22",
              height: "18",
              class: "ml13 fl mt6 mr18"
            }, null, 8, _hoisted_14),
            _hoisted_15,
            _hoisted_16
          ]))
        : _createCommentVNode("", true),
      (_ctx.room.is_owner_group && [-10].includes(_ctx.room.status) && _ctx.canDelete)
        ? (_openBlock(), _createElementBlock("li", {
            key: 5,
            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.showCloseRoomModal && _ctx.showCloseRoomModal(...args))),
            class: "fs12 pointer fw600 pad5",
            style: {"line-height":"40px","width":"160px"}
          }, [
            _createElementVNode("img", {
              src: _ctx.$getAssetImageUrl(`/assets/icons/status_ng.png`),
              width: "17",
              height: "17",
              class: "ml17 fl mt6 mr20",
              style: {}
            }, null, 8, _hoisted_17),
            _hoisted_18,
            _hoisted_19
          ]))
        : _createCommentVNode("", true),
      (_ctx.room.room_type == `public_room`)
        ? (_openBlock(), _createElementBlock("li", {
            key: 6,
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.goSummaryNotFixed(_ctx.room))),
            class: "fs12 pointer fw600 pad5",
            style: {"line-height":"40px","width":"160px"}
          }, [
            _createElementVNode("img", {
              src: _ctx.$getAssetImageUrl(`/assets/icons/vote.png`),
              width: "17",
              height: "17",
              class: "ml15 fl mt4 mr20",
              style: {}
            }, null, 8, _hoisted_20),
            _hoisted_21,
            _hoisted_22
          ]))
        : _createCommentVNode("", true),
      (_ctx.room.room_type == `public_room`)
        ? (_openBlock(), _createElementBlock("li", {
            key: 7,
            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.createFeedback(_ctx.room))),
            class: "fs12 pointer fw600 pad5",
            style: {"line-height":"40px","width":"160px"}
          }, [
            _createElementVNode("img", {
              src: _ctx.$getAssetImageUrl(`/assets/icons/form_icon.png`),
              width: "17",
              height: "17",
              class: "ml15 fl mt4 mr10",
              style: {}
            }, null, 8, _hoisted_23),
            _hoisted_24,
            _hoisted_25
          ]))
        : _createCommentVNode("", true),
      (_ctx.room.room_type == `parent_room` && _ctx.room.is_voted && _ctx.room?.current_appointment?.status == 10)
        ? (_openBlock(), _createElementBlock("li", {
            key: 8,
            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.cancelVoted(_ctx.room))),
            class: "fs12 pointer fw600 pad5",
            style: {"line-height":"40px","width":"160px"}
          }, _hoisted_28))
        : _createCommentVNode("", true),
      (
                    [`parent_room`, `parent_room_group`].includes(_ctx.room.room_type) &&
                    !_ctx.room.is_voted &&
                    _ctx.room?.current_appointment?.status == 10 &&
                    _ctx.room?.current_appointment?.start_time > _ctx.now.toSeconds()
                )
        ? (_openBlock(), _createElementBlock("li", {
            key: 9,
            onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.cancelAppo && _ctx.cancelAppo(...args))),
            class: "fs12 pointer fw600 pad5",
            style: {"line-height":"40px","width":"160px"}
          }, _hoisted_31))
        : _createCommentVNode("", true),
      (
                    ['parent_room', 'parent_room_group'].includes(_ctx.room.room_type) &&
                    !_ctx.Room.isParentActive(_ctx.room.status) &&
                    _ctx.room.status != -10
                )
        ? (_openBlock(), _createElementBlock("li", {
            key: 10,
            onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.changeActive(_ctx.room))),
            class: "fs12 pointer fw600 pad5",
            style: {"line-height":"40px","width":"160px"}
          }, _hoisted_34))
        : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      _createElementVNode("button", {
        class: "dropdown-toggle fw600 fr centered fs12",
        style: {"width":"35px","margin-right":"5%","margin-top":"-3px","background-color":"transparent","border":"none","appearance":"none","padding":"0","outline":"none"},
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clickEditMenu && _ctx.clickEditMenu(...args)))
      }, [
        _createElementVNode("img", {
          src: _ctx.$getAssetImageUrl(`/assets/icons/line3.png`),
          width: "30",
          height: "30",
          class: "fr pointer"
        }, null, 8, _hoisted_1)
      ])
    ]),
    _: 1
  }, 512))
}